export default __webpack_public_path__ + "static/media/breakfast.cb826203.jpeg";